import PropTypes from 'prop-types';

// NOTE: This component should be deprecated in favor of the refactored <ContainerFlex> component.
//       Components to only add CSS classes are discouraged unless absolutely necessary.
const FlexContent = ({ children }) => <div className="flex-1">{children}</div>;

FlexContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FlexContent;
